export default {
  palette: {
    primary: {
      main: '#2493EB',
      contrastText: '#FFFFFF',
    },
    danger: {
      main: '#ED4343',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#1584DD',
      contrastText: '#FFFFFF',
    },
    gray1: '#78849E',
    gray2: '#8A9EB5',
    gray3: '#454F63',
    gray4: '#DFDFE6',
    gray5: '#F7F7FA',
    white: '#FFFFFF',
    green1: '#2FB865',
    yellow1: '#FFD193',
    lightTransparency: '#FFFFFF2E',
    darkTransparency: '#00000014',
  },
  spacing: {
    tinier: '4px',
    tiny: '8px',
    xSmall: '12px',
    small: '16px',
    base: '20px',
    medium: '32px',
    large: '48px',
    xLarge: '64px',
    big: '80px',
    giant: '104px',
  },
  iconSizes: {
    tinier: '4px',
    tiny: '8px',
    xSmall: '16px',
    small: '24px',
    base: '30px',
    medium: '40px',
    large: '50px',
  },
};
